import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Endpoints the backend serves under PUBLIC_ACCESS — they neither require
// nor look at an Authorization header. Attaching an expired token here
// (and pre-emptively 401-ing for it) would break flows that legitimately
// run with no/expired NT2 session, like the silent-SSO id_token exchange
// and the password-reset endpoints.
const PUBLIC_API_URL_PATTERN =
  /^\/api\/(auth\/|users(\?|$)|institutions\/invitations(\/|\?|$))/;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (PUBLIC_API_URL_PATTERN.test(req.url)) {
    return next(req);
  }

  const token = authService.token();
  if (!token) {
    return next(req);
  }

  if (authService.isTokenExpired()) {
    authService.logout();
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: 'Unauthorized',
          error: { error: 'token_expired' },
          url: req.url,
        }),
    );
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(authReq);
};
